import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type IStruxTagActivitySessionsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  infuseId: Types.Scalars['String']['input']
  from?: Types.InputMaybe<Types.Scalars['String']['input']>
  to?: Types.InputMaybe<Types.Scalars['String']['input']>
}>

export type IStruxTagActivitySessionsQuery = {
  struxTagActivitySessions?: Array<{
    id?: any | null
    projectId?: string | null
    infuseId?: string | null
    status?: string | null
    startedAt?: any | null
    endedAt?: any | null
    durationMs?: any | null
    idleDurationMs?: any | null
    movingDurationMs?: any | null
    segments?: Array<{
      state?: string | null
      startedAt?: any | null
      endedAt?: any | null
      durationMs?: any | null
    } | null> | null
  } | null> | null
}

export const StruxTagActivitySessionsDocument = gql`
  query StruxTagActivitySessions(
    $projectId: ObjectId!
    $infuseId: String!
    $from: String
    $to: String
  ) {
    struxTagActivitySessions(
      projectId: $projectId
      infuseId: $infuseId
      from: $from
      to: $to
    ) {
      id
      projectId
      infuseId
      status
      startedAt
      endedAt
      durationMs
      idleDurationMs
      movingDurationMs
      segments {
        state
        startedAt
        endedAt
        durationMs
      }
    }
  }
`

/**
 * __useStruxTagActivitySessionsQuery__
 *
 * To run a query within a React component, call `useStruxTagActivitySessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStruxTagActivitySessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStruxTagActivitySessionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      infuseId: // value for 'infuseId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useStruxTagActivitySessionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    IStruxTagActivitySessionsQuery,
    IStruxTagActivitySessionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IStruxTagActivitySessionsQuery,
    IStruxTagActivitySessionsQueryVariables
  >(StruxTagActivitySessionsDocument, options)
}
export function useStruxTagActivitySessionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IStruxTagActivitySessionsQuery,
    IStruxTagActivitySessionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IStruxTagActivitySessionsQuery,
    IStruxTagActivitySessionsQueryVariables
  >(StruxTagActivitySessionsDocument, options)
}
export type StruxTagActivitySessionsQueryHookResult = ReturnType<
  typeof useStruxTagActivitySessionsQuery
>
export type StruxTagActivitySessionsLazyQueryHookResult = ReturnType<
  typeof useStruxTagActivitySessionsLazyQuery
>
export type StruxTagActivitySessionsQueryResult = Apollo.QueryResult<
  IStruxTagActivitySessionsQuery,
  IStruxTagActivitySessionsQueryVariables
>
